import { styled } from '@mui/material/styles';
import { CircularProgress } from '@mui/material';

const CssCircularProgress = styled(CircularProgress)(({ theme }) => ({
  color: theme.palette.primary.contrastText,
}));

export default CssCircularProgress;